export var INIT = 'analytics/INIT';
export var IDENTIFY = 'analytics/IDENTIFY';
export var CUSTOM = 'analytics/CUSTOM';
export var ERROR = 'analytics/ERROR';
export var PERFORMANCE = 'analytics/PERFORMANCE';
export var NAVIGATION = 'analytics/NAVIGATION';
export var INFORMATION = 'analytics/INFORMATION';
export var TRACK = 'analytics/TRACK';